<accordion [isAnimated]="true" >
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-list-alt'></i> Informacion General
    </span>

    <form class="form-horizontal" [formGroup]="generalnformationForm">
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Personeria</b>
          <span appRequiredAsterisk [formGroup]="generalnformationForm" controlName="personalityDescription"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control"
            formControlName="personalityDescription">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Solicitud</b>
          <span appRequiredAsterisk [formGroup]="generalnformationForm" controlName="requestType"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="requestType" [readonly]="readonly" (change)="requestTypeEmitter.emit($event)">
            <ng-option value="CUSTOMER">Cliente</ng-option>
            <ng-option value="AVAL">Representante</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Plan de Crédito</b>
          <span appRequiredAsterisk [formGroup]="generalnformationForm" controlName="creditPlanDescription"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control"
            formControlName="creditPlanDescription">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Código de Vendedor</b>
          <span appRequiredAsterisk [formGroup]="generalnformationForm" controlName="sellerCode"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="sellerCode">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre de Vendedor</b>
          <span appRequiredAsterisk [formGroup]="generalnformationForm" controlName="sellerName"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="sellerName">
        </div>
      </div>
    </form>
  </accordion-group>
</accordion>
